import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './handover_link.css';

const _HandoverLink = ({ handoverUrl }) => (
    <div>
        <span>If you are not automatically redirected to our trusted partners website within 30 seconds, please click </span>
        <a className={styles.anchor} href={handoverUrl}>here</a>
    </div>
);

_HandoverLink.propTypes = {
    handoverUrl: PropTypes.string
};

const mapStateToProps = (state) => {
    const handoverUrl = state.getIn(['vertical', 'quote', 'results', 'productInfo', 'product', 'quoteUrl']);
    return {
        handoverUrl
    };
};

const HandoverLink = connect(mapStateToProps)(_HandoverLink);

export { _HandoverLink, HandoverLink };
